
import Vue from 'vue';
import Component from 'vue-class-component';
import {
  acceptedModule,
  acceptedState,
  userModule,
  userState
} from '@/utils/store-acessor';
import { UserModel, UserTypes } from '@/models/user.model';
import { ChallengeModel } from '@/models/challenge.model';
import ListScaffold from '@/components/Shared/ListScaffold.vue';
import ChallengeCard from '@/components/ChallengeCard.vue';

interface UserRoleFilter {
  role: UserTypes;
  selected: boolean;
  label: string;
}

@Component({
  components: {
    ChallengeCard,
    ListScaffold
  }
})
export default class MyChallenges extends Vue {
  @acceptedModule.Getter('acceptedChallenges') challenges!: ChallengeModel[];
  @acceptedModule.Getter('loading') loading!: boolean;
  @userModule.Getter('canAcceptChallenges') canAccept!: boolean;
  @userModule.Getter('user') user!: UserModel;
  filters: UserRoleFilter[] = [
    { role: 'advisor', selected: false, label: 'roles.advisor' },
    { role: 'contestant', selected: false, label: 'roles.contestant' },
    { role: 'judge', selected: false, label: 'roles.judge' },
    { role: 'partner', selected: false, label: 'roles.partner' }
  ];

  async mounted() {
    if (!this.user?.id) {
      await userState.fetchUser();
    }
    this.fetchChallenges([]);
  }

  async filterUpdate(selected: UserRoleFilter) {
    this.filters.splice(this.filters.indexOf(selected), 1, {
      ...selected,
      selected: !selected.selected
    });
    this.filters = [...this.filters];
    const roles: UserTypes[] = this.filters
      .filter(v => v.selected)
      .map(v => v.role);
    this.fetchChallenges(roles);
  }

  openChallenge(slug: string) {
    this.$router.push({ path: `/challenges/${slug}` });
  }

  private async fetchChallenges(roles: UserTypes[]): Promise<void> {
    if (!this.user?.contestant?.id) {
      return;
    }
    if (this.canAccept) {
      await acceptedState.fetchMyChallenges({
        roles: roles,
        params: {
          page: 1
        }
      });
    }
  }
}
